<template>
  <div class="base_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('systemManagement') }} > {{ $t('userManagement') }}</div>
    <div class="common-table-cnt common-aside-cnt-top">
      <div class="common-aside">
        <div class="serachBar">{{ $t('Organization') }}</div>
        <el-tree :data="data" :props="defaultProps" node-key="id" default-expand-all :expand-on-click-node="false"
          @node-click="handleNodeClick" highlight-current ref="dataConfigTree">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span v-if="!visible" class="node-txt">{{ node.data.name }}</span>
            <span class="editBtn">
              <img src="@/icon/ic_add.png" class="addicon" v-has="'sys:new:setting:system:org:add'"
                @click="() => append(data, node)" />
              <img src="@/icon/ic_edit.png" class="addicon" v-has="'sys:new:setting:system:org:edit'"
                @click="editOrgunit(data, node)" />
              <img src="@/icon/ic_delete.png" class="addicon" v-has="'sys:new:setting:system:org:del'"
                @click="() => remove(node, data)" />
            </span>
          </span>
        </el-tree>
      </div>
      <div class="common-aside-main" style="right:15px;">
        <div class="search search-container">
          <!-- 根据条件查询列表 -->
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item :label="$t('fullName')">
              <el-input v-model="formInline.userName" clearable :placeholder="$t('fullName')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('accountNumber')">
              <el-input v-model="formInline.account" clearable :placeholder="$t('accountNumber')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('state')">
              <el-select v-model="formInline.status" clearable :placeholder="$t('state')"
                :popper-append-to-body="false">
                <el-option :label="$t('enable')" value="1"></el-option>
                <el-option :label="$t('disable')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList">{{ $t('query') }}</el-button>
              <el-button type="primary" @click="addUser" v-has="'sys:new:setting:system:user:add'">{{
      $t('newlyAded')
    }}</el-button>
              <el-button type="primary" @click="exportExcel" v-has="'sys:new:setting:system:user:import'"
                :loading="exportLoading" class="add-btn down-btn">{{ $t('downloadTemplate') }}
              </el-button>
              <el-upload v-has="'sys:new:setting:system:user:import'" action="string" :http-request="importExcel"
                :multiple="false" :show-file-list="false">
                <el-button type="primary" class="add-btn" :loading="importLoading">{{
      $t('batchImportAdd')
    }}</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <div class="main table-box">
          <!-- table 列表 -->
          <el-table :data="tableData" style="width: 100%;" @sort-change="sortChange">
            <el-table-column type="index" :index="indexMethod" :label="$t('SerialNo')" align="center" width="80"
              :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" :label="$t('fullName')" min-width="120" sortable="name"
              :sort-orders="['ascending', 'descending']">
            </el-table-column>
            <el-table-column prop="ouName" :label="$t('mechanism')" min-width="140" sortable="custom_ou.name"
              :sort-orders="['ascending', 'descending']">
            </el-table-column>
            <el-table-column prop="status" :label="$t('state')" width="100" align="center" sortable="status"
              :sort-orders="['ascending', 'descending']">
              <template slot-scope="scope">{{ scope.row.status === 1 ? $t('enable') : ''
                }}{{ scope.row.status === 0 ? $t('disable') : '' }}</template>
            </el-table-column>
            <el-table-column prop="phone" :label="$t('phoneNumber')" min-width="100" align="right" sortable="phone"
              :sort-orders="['ascending', 'descending']">
            </el-table-column>
            <el-table-column prop="account" :label="$t('accountNumber')" min-width="120" sortable="account"
              :sort-orders="['ascending', 'descending']">
            </el-table-column>
            <el-table-column prop="roleName" :label="$t('role')" :formatter="fileData" min-width="100"
              sortable="custom_r.name" :sort-orders="['ascending', 'descending']">
            </el-table-column>
            <el-table-column :label="$t('operationh')"
              v-has="'sys:new:setting:system:user:del' || 'sys:new:setting:system:user:edit'" min-width="160"
              align="center">
              <template slot-scope="scope">
                <span class="editClick" @click="UserEditHandleClick(scope.row)"
                  v-has="'sys:new:setting:system:user:edit'" v-if="scope.row.isAdmin === 0">{{ $t('edit') }}</span>
                <span class="editClick" @click="delUser(scope.row)" v-has="'sys:new:setting:system:user:del'"
                  v-if="scope.row.isAdmin == 0">{{ $t('delete') }}</span>
                <span class="editClick" @click="PassWordEditHandleClick(scope.row)"
                  v-if="loginIsAdmin === '1' && scope.row.isAdmin === 0 && scope.row.account">{{ $t('resetPassword')
                  }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalData">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--新增/编辑用户窗口-->
    <el-dialog :title="userDialog ? $t('newUser') : $t('editUser')" :visible.sync="newUserDialogTableVisible"
      class="userDialog common-blue-contain" :append-to-body="true" :close-on-click-modal="false">
      <el-form :model="newUserForm" :rules="userRules" ref="newUserForm">
        <div class="linetwo">
          <div class="leftColumn">
            <el-form-item :label="$t('fullName')" :label-width="formLabelWidth" :required="true">
              <el-input v-model="newUserForm.name" autocomplete="off" :placeholder="$t('pleaseEnter') + $t('fullName')"
                class="formInput" clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('mechanism')" :label-width="formLabelWidth" class="department" :required="true">
              <el-select ref="paramOuSelect" v-model="currentNode" style="width:auto"
                :placeholder="$t('peaseSelect')" :popper-append-to-body="false" @change="changeParamOu"
                clearable @visible-change="visibleChange">
                <el-option :value="currentNode" style="height:auto;padding:0px">
                  <el-tree ref="paramOuTree" node-key="ouId" default-expand-all highlight-current
                    :expand-on-click-node="false" :data="data" :props="defaultProps" @node-click="handleTree">
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('accountNumber')" :label-width="formLabelWidth" v-if="turnOn == true"
              :required="true">
              <el-input v-model="newUserForm.account" :disabled="newUserForm.isAdmin === 1" autocomplete="off"
                :placeholder="$t('pleaseEnter') + $t('accountNumber')" class="formInput" clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('initialPassword')" :label-width="formLabelWidth"
              v-if="userDialog === true && turnOn === true" :required="true" prop="pwd">
              <el-input v-model="newUserForm.pwd" autocomplete="off"
                :placeholder="$t('initialPassword')" class="formInput" auto-complete="new-password"
                clearable show-password></el-input>
            </el-form-item>
          </div>
          <div class="rightColumn">
            <el-form-item :label="$t('phoneNumber')" :label-width="formLabelWidth">
              <el-input v-model="newUserForm.phone" autocomplete="off" maxlength="11" class="formInput" readonly
                :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('state')" :label-width="formLabelWidth" :required="true">
              <el-radio-group v-model="newUserForm.status" @change="onOff" :disabled="newUserForm.isAdmin == 1">
                <el-radio :label="1" value="1">{{ $t('enable') }}</el-radio>
                <el-radio :label="0" value="0">{{ $t('disable') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('role')" :label-width="formLabelWidth" v-if="turnOn == true" :required="true">
              <el-select v-model="newUserForm.roleId" multiple class="formInput" :disabled="newUserForm.isAdmin === 1"
                @change="$forceUpdate()" :popper-append-to-body="false">
                <el-option v-for="item of roleList" :label="item.name" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('confirmPassword')" :label-width="formLabelWidth"
              v-if="userDialog === true && turnOn === true" :required="true" prop="confirmPwd">
              <el-input v-model="newUserForm.confirmPwd" autocomplete="off"
                :placeholder="$t('confirmPassword')" class="formInput" clearable
                show-password></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormUser()">{{ $t('determine') }}</el-button>
        <el-button @click="cancelFrom">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--重置密码窗口-->
    <el-dialog :title="$t('resetLoginPassword')" :visible.sync="passWordDialogTableVisible"
      class="resetPasswordDialog common-blue-contain" :append-to-body="true" @close="cancelRestPass('passWordForm')"
      :close-on-click-modal="false" width="540px">
      <el-form :model="passWordForm" :rules="rules" ref="passWordForm">
        <!-- <div class=""> -->
        <el-form-item :label="$t('newPassword')" :label-width="formLabelWidth" prop="pass">
          <el-input v-model="passWordForm.pass" autocomplete="off" :placeholder="$t('pleaseEnter') + $t('newPassword')"
            show-password></el-input>
        </el-form-item>
        <el-form-item :label="$t('confirmNewpassword')" :label-width="formLabelWidth" prop="checkPass">
          <el-input v-model="passWordForm.checkPass" autocomplete="off"
            :placeholder="$t('pleaseEnter') + $t('confirmNewpassword')" show-password></el-input>
          <span v-if="checkPassSame">{{ $t('passwordsEnteredTwice') }}</span>
        </el-form-item>
        <!-- </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePassWord('passWordForm')">{{ $t('determine') }}</el-button>
        <el-button @click="cancelRestPass('passWordForm')">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增编辑组织机构 -->
    <el-dialog :title="treeDialog ? $t('newInstitutions') : $t('editorialBody')" :visible.sync="treeVisible"
      width="400px" class="treeDialog common-blue-contain" :append-to-body="true" :close-on-click-modal="false">
      <el-form :model="treeFrom" label-width="150px">
        <el-form-item :label="$t('organizationName')" :required="true">
          <el-input v-model="treeFrom.name" autocomplete="off" :placeholder="$t('pleaseEnterOrganization')"
            clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormTree">{{ $t('determine') }}</el-button>
        <el-button @click="treeVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { errorCollection } from '@/api/dmp/dmpCollection'
import {
  getUser,
  getRoles,
  getOus,
  saveUser,
  delUser,
  editUser,
  resetPassword,
  saveOrgunit,
  deleteOrgunit,
  editOrgunit,
  exportExcel,
  importExcel,
} from '@/api/UserList'
import { encrypt } from '@/util/rsaEncryptor'
import { setSession, getSession, formatDate } from '@/api/common'
import { refreshToken } from '@/api/login'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  name: 'UserManage',
  components: { Treeselect },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === undefined) {
        errorCollection('设置》用户管理', '重置密码', { status: 200, data: { state: -1, msg: '请输入新密码' } })
        callback(new Error(this.$t('pleaseEnter') + this.$t('newPassword')))
      } else {
        if (this.passWordForm.checkPass !== '') {
          this.$refs.passWordForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === undefined) {
        errorCollection('设置》用户管理', '重置密码', { status: 200, data: { state: -1, msg: '请再次输入密码' } })
        callback(new Error(this.$t('enterPasswordAgain')))
      } else if (value !== this.passWordForm.pass) {
        errorCollection('设置》用户管理', '重置密码', { status: 200, data: { state: -1, msg: '两次输入密码不一致' } })
        callback(new Error(this.$t('passwordsEnteredTwice')))
      } else {
        callback()
      }
    }
    var validateNewPass2 = (rule, value, callback) => {
      console.log(value,'value')
      if (value === undefined || !value) {
        errorCollection('设置》用户管理', '重置密码', { status: 200, data: { state: -1, msg: '请再次输入密码' } })
        callback(new Error(this.$t('enterPasswordAgain')))
      } else if (value !== this.newUserForm.pwd) {
        errorCollection('设置》用户管理', '重置密码', { status: 200, data: { state: -1, msg: '两次输入密码不一致' } })
        callback(new Error(this.$t('passwordsEnteredTwice')))
      } else {
        callback()
      }
    }
    return {
      // 登录账户是否为admin
      loginIsAdmin: sessionStorage.getItem('isAdmin') + '',
      formInline: {
        userName: '',
        account: '',
        status: '',
      },
      // 表格数据
      tableData: [],
      // 角色列表
      roleList: [],
      // 新增/编辑用户窗口显示
      newUserDialogTableVisible: false,
      // 重置登录密码弹窗显示
      passWordDialogTableVisible: false,
      // 新增/编辑用户 表单参数
      newUserForm: {
        name: '',
        roleId: [],
        ouId: null,
        pwd: '',
        account: '',
        status: '',
        phone: '',
        id: '',
        isAdmin: 0,
        confirmPwd: '',
      },
      formLabelWidth: '185px',
      // true：新增 false：编辑
      userDialog: true,
      newUserDialogTableVisibleBefore: null,
      // 架构树
      filterText: '',
      data: [],
      // 重置密码参数
      passWordForm: {
        pass: '',
        checkPass: '',
        name: '',
        roleId: [],
        ouId: '',
        account: '',
        status: '',
        phone: '',
        id: '',
        confirmPwd: '',
      },
      // 重置密码验证输入
      rules: {
        pass: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { min: 8, message: this.$t('enterLeastCharacters'), trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/
              if (!passwordreg.test(value)) {
                callback(new Error(this.$t('letterSpecialCharacters')))
              } else {
                callback()
              }
            },
          },
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          { min: 8, message: this.$t('enterLeastCharacters'), trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/
              if (!passwordreg.test(value)) {
                callback(new Error(this.$t('letterSpecialCharacters')))
              } else {
                callback()
              }
            },
          },
        ],
      },
      ousData: [],
      // 机构树租户数据格式
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      visible: false,
      turnOn: false,
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      ouId: '',
      currentNode: null,
      treeVisible: false,
      treeDialog: false,
      appendNode: '',
      treeFrom: {
        children: '',
        id: '',
        name: '',
        pid: '',
        sortOrder: '',
      },
      userRules: {
        pwd: [
          { required: true, message: this.$t('enterInitialPassword'), trigger: 'blur' },
          { min: 8, message: this.$t('enterLeastCharacters'), trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/
              if (!passwordreg.test(value)) {
                callback(new Error(this.$t('letterSpecialCharacters')))
              } else {
                callback()
              }
            },
          },
        ],
        confirmPwd: [
          { required: true, validator: validateNewPass2, trigger: 'blur' },
          { min: 8, message: this.$t('enterLeastCharacters'), trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/
              if (!passwordreg.test(value)) {
                callback(new Error(this.$t('letterSpecialCharacters')))
              } else {
                callback()
              }
            },
          },
        ],
      },
      checkPassSame: false,
      exportLoading: false,
      importLoading: false,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    currentNode: {
      handler() {
        if (this.newUserForm.ouId === '') {
          this.newUserForm.ouId = null
        }
        this.$emit('input', this.newUserForm.ouId)
      },
      immediate: true,
    },
  },
  methods: {
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formInline.sortColName = !order ? null : column.sortable
      this.formInline.useAsc = order === 'descending' ? 0 : 1
      this.getList()
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    exportExcel() {
      this.exportLoading = true
      exportExcel().then(res => {
        if (!res['state']) {
          let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, 'importTemplate')
          } else {
            // 非IE下载
            const elink = document.createElement('a')
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            elink.download = this.$t('importUserTemplates') + formatDate(new Date(), 'yyyyMMddhhmmss')
            document.body.appendChild(elink)
            elink.click()
            setTimeout(() => {
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            }, 5000) //解决部分浏览器下载时“无此文件”问题
          }
        } else {
          this.$message({
            type: 'error',
            message: this.$t('failedDownloadTemplate'),
            customClass: 'zZindex',
            duration: 2000,
          })
        }
        this.exportLoading = false
      })
    },
    importExcel(params) {
      this.importLoading = true
      const _file = params.file
      // 通过 FormData 对象上传文件
      let formData = new FormData()
      formData.append('file', _file)
      importExcel(formData).then(res => {
        if (res['type'] !== 'application/json') {
          this.$confirm(this.$t('Importfailed'), {
            confirmButtonText: this.$t('download'),
            cancelButtonText: this.$t('cancel'),
            type: 'error',
            closeOnClickModal: false,
          })
            .then(() => {
              let errorImportBlob = new Blob([res], {
                type: 'application/vnd.ms-excel',
              }) // res就是接口返回的文件流了
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(errorImportBlob, 'errorImportData')
              } else {
                // 非IE下载
                const errorImportDataElink = document.createElement('a')
                errorImportDataElink.style.display = 'none'
                errorImportDataElink.href = URL.createObjectURL(errorImportBlob)
                errorImportDataElink.download = this.$t('importWrongUser') + formatDate(new Date(), 'yyyyMMddhhmmss')
                document.body.appendChild(errorImportDataElink)
                errorImportDataElink.click()
                setTimeout(() => {
                  URL.revokeObjectURL(errorImportDataElink.href) // 释放URL 对象
                  document.body.removeChild(errorImportDataElink)
                }, 5000) //解决部分浏览器下载时“无此文件”问题
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('errorDataCanceled'),
              })
            })
        } else {
          this.$message({
            type: 'success',
            message: this.$t('importComplete'),
          })
          this.getList()
        }
        this.importLoading = false
      })
    },
    normalizer(node) {
      // 去掉children=null的children属性
      if (node.children === null) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      }
    },
    // 取消重置密码
    cancelRestPass(formName) {
      this.passWordDialogTableVisible = false
      this.checkPassSame = false
      this.$nextTick(function () {
        this.$refs[formName].resetFields()
      })
    },
    // 新增时当前选择的机构
    handleTree(data) {
      this.currentNode = data.name
      this.newUserForm.ouId = data.id
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.currentNode = null
        this.newUserForm.ouId = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 当前机构/用户
    handleNodeClick(data, node) {
      this.currentPage = 1
      this.$refs.dataConfigTree.setCurrentKey(node.id)
      this.ouId = data.id
      this.search()
      this.currentNode = data.name
    },
    // 提交组织机构
    submitFormTree() {
      if (this.treeDialog) {
        let params = {
          children: this.treeFrom.children,
          name: this.treeFrom.name,
          pid: this.treeFrom.id,
        }
        saveOrgunit(params).then(res => {
          if (res.state === 0) {
            this.$message({ type: 'success', message: this.$t('AddSuccess') })
            this.getOusTree()
            this.treeVisible = false
            this.refreshToken()
          }
        })
      } else {
        let params = {
          children: this.treeFrom.children,
          id: this.treeFrom.id,
          name: this.treeFrom.name,
          pid: this.treeFrom.pid,
          sortOrder: this.treeFrom.sortOrder,
        }
        editOrgunit(params).then(res => {
          if (res.state === 0) {
            this.$message({ type: 'success', message: this.$t('EditSucceeded') })
            this.treeVisible = false
          }
          this.getOusTree()
        })
      }
    },
    // 组织架构编辑
    editOrgunit(data) {
      this.treeDialog = false
      this.treeVisible = true
      this.treeFrom = {
        children: data.children,
        id: data.id,
        name: data.name,
        pid: data.pid,
        sortOrder: data.sortOrder,
      }
    },
    // 添加组织架构
    append(data) {
      this.treeVisible = true
      this.treeDialog = true
      this.treeFrom = {
        children: data.children,
        id: data.id,
        name: '',
        pid: data.pid,
        sortOrder: data.sortOrder,
      }
    },
    // 移除组织架构节点
    remove(node, data) {
      this.$confirm(this.$t('deleteThisNode'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      })
        .then(() => {
          let params = {
            id: data.id,
            name: data.name,
            pid: data.pid,
            sortOrder: data.sortOrder,
          }
          deleteOrgunit(params).then(res => {
            if (res.state === 0) {
              if (this.ouId === data.id) {
                this.ouId = null
              }
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
              })
              this.getOusTree()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('deletionCancelled'),
          })
        })
    },
    // 查询
    getList() {
      this.currentPage = 1
      this.search()
    },
    // 获取用户列表
    search() {
      let params = {
        name: this.formInline.userName,
        account: this.formInline.account,
        status: this.formInline.status,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.ouId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getUser(params).then(res => {
        if (res.state === 0) {
          this.tableData = res.data.list
          this.totalData = res.data.total
        } else {
          console.log(res.msg)
        }
      })
    },
    // 新增用户
    addUser() {
      this.turnOn = false
      this.userDialog = true
      this.getRoles()
      this.getOusTree()
      this.newUserForm = {
        name: '',
        roleId: [],
        ouId: null,
        pwd: '',
        account: '',
        status: 0,
        phone: '',
        confirmPwd: '',
      }
      this.newUserForm.ouId = this.ouId === '' ? null : this.ouId
      this.newUserDialogTableVisible = true
    },
    // 删除用户
    delUser(row) {
      this.$confirm(this.$t('deleteThisUser'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        delUser(row).then(res => {
          if (res.state === 0) {
            this.search()
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
          }
        })
      })
    },
    // 获取角色列表
    getRoles() {
      getRoles().then(res => {
        if (res.state === 0) {
          this.roleList = res.data
        }
      })
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.data = res.data
        }
      })
    },
    // 新增/编辑状态
    onOff(e) {
      if (e === 1) {
        this.turnOn = true
      } else if (e === 0) {
        this.turnOn = false
      }
    },
    // 提交新增用户
    submitFormUser() {
      let obj = this.newUserForm
      if (this.userDialog) {
        let param = {
          name: obj.name,
          roleId: obj.roleId,
          ouId: obj.ouId,
          pwd: obj.pwd,
          account: obj.account,
          status: obj.status,
          phone: obj.phone,
          confirmPwd: obj.confirmPwd,
        }
        if (!param.name) {
          errorCollection('设置》用户管理', '新增/编辑用户', { status: 200, data: { state: -1, msg: '请输入姓名' } })
          this.$message.error(this.$t('pleaseEnter') + this.$t('fullName'))
        } else if (!param.ouId) {
          errorCollection('设置》用户管理', '新增/编辑用户', { status: 200, data: { state: -1, msg: '请选择机构' } })
          this.$message.error(this.$t('peaseSelect'))
        } else if (param.status === '') {
          errorCollection('设置》用户管理', '新增/编辑用户', { status: 200, data: { state: -1, msg: '请选择状态' } })
          this.$message.error(this.$t('selectSstatus'))
        } else if (param.status === 0) {
          this._saveAddUser(param)
        } else if (param.status === 1) {
          this.enableVerificat(param)
        }
      } else {
        this._saveEditUser(obj)
      }
    },
    enableVerificat(param) {
      if (param.account === '') {
        errorCollection('设置》用户管理', '新增/编辑用户', { status: 200, data: { state: -1, msg: '请输入用户账号' } })
        this.$message.error(this.$t('pleaseEnter') + this.$t('accountNumber'))
      } else if (param.roleId.length === 0) {
        errorCollection('设置》用户管理', '新增/编辑用户', {
          status: 200,
          data: { state: -1, msg: '请至少选择一个角色' },
        })
        this.$message.error(this.$t('selectatLeastRole'))
      } else if (param.pwd === '') {
        errorCollection('设置》用户管理', '新增/编辑用户', { status: 200, data: { state: -1, msg: '请输入新密码' } })
        this.$message.error(this.$t('pleaseEnter') + this.$t('newPassword'))
      } else if (param.confirmPwd === '') {
        errorCollection('设置》用户管理', '新增/编辑用户', { status: 200, data: { state: -1, msg: '请输入确认密码' } })
        this.$message.error(this.$t('pleaseEnter') + this.$t('confirmPassword'))
      } else if (param.pwd !== param.confirmPwd) {
        errorCollection('设置》用户管理', '新增/编辑用户', {
          status: 200,
          data: { state: -1, msg: '两次密码输入不一样' },
        })
        this.$message.error(this.$t('passwordsEnteredTwice'))
      } else {
        this._saveAddUser(param)
      }
    },
    _saveAddUser(param) {
      param.pwd = encrypt(param.pwd)
      param.confirmPwd = encrypt(param.confirmPwd)
      this.$refs['newUserForm'].validate(valid => {
        if (valid) {
          saveUser(param).then(res => {
            if (res.state === 0) {
              this.search()
              this.$message({
                type: 'success',
                message: this.$t('AddSuccess'),
              })
              this.newUserDialogTableVisible = false
            }
          })
        }
      })
    },
    _saveEditUser(obj) {
      let param = {
        name: obj.name,
        roleId: obj.roleId,
        ouId: obj.ouId,
        pwd: null,
        account: obj.account,
        status: obj.status,
        phone: obj.phone,
        id: obj.id,
      }
      if (param.name === '') {
        errorCollection('设置》用户管理', '编辑用户', { status: 200, data: { state: -1, msg: '请输入姓名' } })
        this.$message.error(this.$t('pleaseEnter') + this.$t('fullName'))
      } else if (param.ouId === '') {
        errorCollection('设置》用户管理', '编辑用户', { status: 200, data: { state: -1, msg: '请选择机构' } })
        this.$message.error(this.$t('peaseSelect'))
      } else if (param.status === '') {
        errorCollection('设置》用户管理', '编辑用户', { status: 200, data: { state: -1, msg: '请选择状态' } })
        this.$message.error(this.$t('selectSstatus'))
      } else {
        editUser(param).then(res => {
          if (res.state === 0) {
            this.search()
            this.$message({
              type: 'success',
              message: this.$t('EditSucceeded'),
            })
            this.newUserDialogTableVisible = false
            let userId = getSession('userId')
            if (userId === param.id) {
              this.refreshToken()
            } else {
              this.search()
            }
          }
        })
      }
    },
    refreshToken() {
      let params = {
        refresh_token: getSession('refresh_token'),
        grant_type: 'refresh_token',
      }
      refreshToken(params).then(_res => {
        let state = _res.state
        if (state === 0) {
          let res = _res
          sessionStorage.setItem('featureCode', res.featureCode)
          setSession('access_token', res.token_type + ' ' + res.access_token)
          setSession('refresh_token', res.refresh_token)
          setSession('expireTime', res.expiration)
        }
        this.search()
      })
    },
    // 提交密码
    savePassWord(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = this.passWordForm
          let param = {
            name: obj.name,
            roleId: obj.roleId,
            ouId: obj.ouId,
            account: obj.account,
            status: obj.status,
            phone: obj.phone,
            pwd: encrypt(this.passWordForm.pass),
            id: obj.id,
            confirmPwd: encrypt(this.passWordForm.checkPass),
          }
          resetPassword(param).then(res => {
            if (res.state === 0) {
              this.$message({
                type: 'success',
                message: this.$t('passwordResetSucceeded'),
              })
              this.passWordDialogTableVisible = false
            }
          })
        }
      })
    },
    cancelFrom() {
      this.newUserDialogTableVisible = false
      this.search()
    },
    // 编辑用户
    UserEditHandleClick(row) {
      if (row.status === 1) {
        this.turnOn = true
      } else {
        this.turnOn = false
      }
      this.newUserDialogTableVisibleBefore = Object.assign({}, row)
      let roleIds = []
      for (let item of row.roles) {
        roleIds.push(item.id)
      }
      this.newUserDialogTableVisibleBefore.roleId = roleIds
      this.userDialog = false
      this.getRoles()
      this.getOusTree()
      this.newUserDialogTableVisible = true
      this.currentNode = row.ouName
      this.$nextTick(() => {
        this.newUserForm = this.newUserDialogTableVisibleBefore
      })
    },
    // 重置密码
    PassWordEditHandleClick(row) {
      this.passWordForm = Object.assign({}, row)
      let roleIds = []
      for (let item of row.roles) {
        roleIds.push(Number(item.id))
      }
      this.passWordForm.roleId = roleIds
      this.passWordDialogTableVisible = true
    },
    // 每页查询 val 条数据
    handleSizeChange(val) {
      this.pageSize = val
      this.search()
    },
    // 点击页数跳转到 val 页
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    indexMethod(index) {
      return index + 1
    },
    // 多个角色风格处理
    fileData(row) {
      let arr = []
      row.roles.forEach(item => {
        arr.push(item.name)
      })
      return arr.join(',')
    },
  },
  mounted() {
    this.search()
    this.getOusTree()
    setInterval(function () {
      document.querySelectorAll('.el-cascader-node__label').forEach(el => {
        el.onclick = function () {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 645px
  min-height 460px;/* no */
>>>.el-tree-node__content:hover .editBtn
  display inline-block
.base_main
  .common-aside-main
    margin-left 10px
  >>>.el-tree
    height 94%
    overflow auto
  .serachBar
    padding 10px
    font-weight: bold
    font-size 16px
    // color #fff
  .serachBtn
    margin-left 40%
  .serachBar:before
    display inline-block
    content ''
    width 3px
    height 15px
    margin-right 10px
    border-radius 3px
    background-color #0e65dd
    .el-input
      width 100%
  .editBtn
    display none
    .addicon
      margin-right 10%
      width 20px
      height 20px
  .title
    font-size 16px
    margin-bottom 28px
  .main
    .user_input
      margin-top 10px
      width 100px
      margin-left 10px
    .el-button
      margin-left 10px
    .pagination
      float right
      margin-top 1%
.linetwo
  display flex
  overflow hidden
  flex-direction row
  .leftColumn
    flex 0 0 50%
  .rightColumn
    flex 0 0 50%
.custom-tree-node
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 0.10416667rem;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  .node-txt
    font-size 16px;/*no*/
.el-form-item__content
  span
    position absolute
    left 0
    top 32px
    font-size 14px
    color #ed3f14
.department
  .tree-input
    border 1px solid #eff2f5
    border-radius 5px
    max-height 200px
    overflow auto
.el-message-box .el-message-box__title span
  display block
.el-message-box .el-message-box__title span:first-letter
  color red !important
.organiza .el-form-item
  display flex
.vue-treeselect
  width 100%!important; /* no */
  z-index 99999999999
>>>.el-popper
 width 100%!important
.userDialog
  >>>.el-popper
    width 228px!important; /* no */
  .el-select
    width 100%!important;
.down-btn
  margin-right 16px
.theme-dark
  .serachBar:before
    background-color #00DDFE
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 644px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
